export default __webpack_public_path__ + "static/media/ic_orange_arrow_badge.5b14f456.svg";